import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './counterSlice';
import userReducer from './userReducer';
import siteAuditSlice from './siteAuditReducer';
import userManagementSlice from './userManagementReducer';
import keywordResearchSlice from './keywordResearch';
import dashboardSlice from './dashboard';
import localSeoSlice from './localSeo';

/**
 * Redux store for managing application state.
 *
 * @name store
 * @type {Store}
 */
export const store = configureStore({
  reducer: {
    /**
     * Reducer for managing counter-related state.
     *
     * @type {Reducer}
     */
    counter: counterReducer,

    /**
     * Reducer for managing user-related state.
     *
     * @type {Reducer}
     */
    user: userReducer,

    /**
     * Reducer for managing site audit-related state.
     *
     * @type {Reducer}
     */
    siteAudit: siteAuditSlice,
    /**
     * Reducer for managing user management-related state.
     *
     * @type {Reducer}
     */
    userManagement: userManagementSlice,
    /**
     * Reducer for managing keyword research-related state.
     *
     * @type {Reducer}
     */
    keywordResearch: keywordResearchSlice,
    /**
     * Reducer for managing dashboard-related state.
     *
     * @type {Reducer}
     */
    dashboard: dashboardSlice,
    /**
     * Reducer for managing dashboard-related state.
     *
     * @type {Reducer}
     */
    localSeo: localSeoSlice,
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
